/**
 * @file updated-kyc-details.tsx
 * @module app/modals/updated-kyc-details
 * @description Renders the updated kyc details modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { useEffect, useState } from "react";
import { Card, ListGroup, Modal } from "react-bootstrap";
import APICallService from "../../api/apiCallService";
import { seller } from "../../api/apiEndPoints";
import Loader from "../../Global/loader";
import CrossSvg from "../../_admin/assets/media/close.png";
import Method from "../../utils/methods";
import { warehouse as warehouseStoreString } from '../../utils/storeString';
import { getKey } from "../../Global/history";
import { useWarehouse } from "../context/WarehouseContext";
const UpdatedKycDetails = (props: any) => {
  
  const { selectedWarehouse } = useWarehouse();
  const [loading, setLoading] = useState(false);
  const [logsData, setLogsData] = useState<any>([]);

  const [show, setShow] = useState(false);
  useEffect(() => {
    (async () => {
      setLoading(true);
      if (props.show) {
        await fetchUpdateLogs();
      }
    })();
  }, []);

  const fetchUpdateLogs = async () => {
    let apiService = new APICallService(seller.profileUpdateLogs, props._id,'','','','',props.moduleName,selectedWarehouse?.value || null);
    let response = await apiService.callAPI();
    if (response) {
      setLogsData(response.records);
      setLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      dialogClassName="min-w-lg-590px"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="border-bottom-0 pb-0 text-center mx-auto">
        <img
          className="close-inner-top"
          width={40}
          height={40}
          src={CrossSvg}
          alt="closebutton"
          onClick={props.onHide}
        />
        <Modal.Title className="fs-26 fw-bolder mw-lg-375px pt-5">
          {props.ownerName} has updated the below details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Loader loading={loading} />
            </div>
          ) : (
            <ListGroup className="p-5">
              {logsData.map((logVal: any, index: number) => {
                return (
                  <ListGroup.Item className="fs-18 fw-500 py-3 d-flex flex-column">
                    {logVal.updates}
                    <span className="fs-15 fw-500 text-gray">
                      Updated on{" "}
                      {Method.convertDateToDDMMYYYYHHMM(logVal._createdAt)}
                    </span>
                  </ListGroup.Item>
                );
              })}
            </ListGroup>
          )}
        </Card>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default UpdatedKycDetails;
